
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<BlockLogs>({ })
export default class BlockLogs extends Vue {
  @Prop()
  private logs!: any[];

  protected get statuses(): any {
    return {
      'pending': 'Pending',
      'on_hold_photos': 'On Hold: Photo\'s',
      'on_hold_credit_check': 'On Hold: Credit check',
      'on_hold_budget': 'On Hold: Budget',
      'to_be_contacted': 'To be contacted',
      'waiting_for_reply': 'Waiting for reply',
      'no_reply': 'No reply',
      'on_hold_other': 'On Hold: Other',
      'order_in_progress': 'To be styled',
      'backorder': 'Backorder',
      'completed': 'Completed',
      'canceled': 'Cancelled',
    };
  }
}
